export const characters = [
    {
        name: "Toph",
        image: require("../img/Toph.png"),
        type: "EarthBender",
        abilities: ["Def structure",],
        color: "green",
        isNew: true,
    },
    {
        name: "Azula",
        image: require("../img/azula.png"),
        type: "FireBender",
        abilities: ["Next attack card is free", "Lighting attack",],
        color: "red",
    },
    {
        name: "kora",
        image: require("../img/kora.png"),
        type: "WaterBender",
        abilities: ["Shoots 2x ice spikes deals 4dmg",],
        color: "blue",
        isNew: true,
    },
    {
        name: "Zuko",
        image: require("../img/Zuko.png"),
        type: "FireBender",
        abilities: ["Deals powerfull kick 7dmg",],
        color: "red"
    },
    {
        name: "Iroh",
        image: require("../img/Iroh.webp"),
        type: "FireBender",
        abilities: ["Draw card",],
        color: "red"
    },
    {
        name: "giastsu",
        image: require("../img/giastsu.png"),
        type: "Airbender",
        abilities: ["Skip enemy turn",],
        color: "gray",
        isNew: true,
    },
    {
        name: "Katara",
        image: require("../img/katara.png"),
        type: "WaterBender",
        abilities: ["Heals herself 4hp",],
        color: "blue"
    },
    {
        name: "tenzin",
        image: require("../img/tenzin.png"),
        type: "Airbender",
        abilities: ["Next normal spell will be upgraded into golden",],
        color: "gray"
    },
    {
        name: "bumi",
        image: require("../img/bumi.png"),
        type: "EarthBender",
        abilities: ["Rock throw",],
        color: "green",
        isNew: true,
    },
    {
        name: "kioshi",
        image: require("../img/kioshi.png"),
        type: "EarthBender",
        abilities: ["Lower enemy defense stats",],
        color: "green"
    },
    {
        name: "Yue",
        image: require("../img/Yue.png"),
        type: "WaterBender",
        abilities: ["Skips his own turn",],
        color: "blue"
    },
    {
        name: "Aang",
        image: require("../img/q1.png"),
        type: "Airbender",
        abilities: ["Regenerates energy", "...", "..."],
        color: "gray"
    }
];
